import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep.js';
import { useOwner } from '../context/context.js';

import ActionLink from '../builder/ActionLink';
import InputWithButton from '../builder/InputWithButton';
import Select from '../builder/Select';

import { ProfileModule } from '../ui_items/Module.js';

const PromoStatus = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const status = owner?.status ?? 'draft';
	if(status != 'expired') return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [config, setConfig] = useState(promotion?.config || {});

	let expired_behaviour_options = [{ k:'0', v:"Show expired page" }];
	if(promotion.win_published && !window.is_post_date) {
		expired_behaviour_options.push({ k:'2', v:"Show winners" });
	}
	expired_behaviour_options.push({ k:'4', v:"Redirect to URL" });
	
	const saveExpirationUrl = (v) => {
		changeConfig('expired_url', v);
	};

	const changeConfig = (k, v) => {
		let _config = {...config};
		_config[k] = v;
		setConfig(_config);

		$.post(`/promotions/saveConfig/${promotion.id}`, { id:k, info:v }, (r) => {
			if(r.redirect_url != undefined) window.location.href = r.redirect_url;
			(r?.status ?? true) ? EP.showSuccessSave() : EP.showErrorSave();
		}, 'JSON');
	};

	return (
		<ProfileModule _class={{ padding:false, other:'gui_hidden_overflowed' }}>
			<header class="module_header whiteColor old_status redBg empty_contents in_top" style={{ border:'none' }}>
				<h2 class="h knk-item-old">{i18n("Status")}: {i18n("Expired")}</h2>
			</header>

			{(window.user_role != '1') && (
				<div class="gui_is_padded gui_padded_in_top">
					<Select
						name="expired_behaviour"
						_class={{size:60, first:true}}
						values={expired_behaviour_options}
						model={config}
						change={changeConfig}
					>What to do</Select>

					{(config.expired_behaviour == '0') && (
						<div class="gui_link_actions gui_flex_end gui_not_in_top_tiny">
							<ActionLink
								_href={getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'expired_promo')}
							>Edit page</ActionLink>
						</div>
					)}

					{(config.expired_behaviour == '4') && (
						<InputWithButton
							value={config.expired_url}
							submitIcon='knk-arrow-r-big'
							name="expired_url"
							placeholder={`https://${i18n("www.your-domain.com")}`}
							onSubmit={(v) => saveExpirationUrl(v)}
						/>
					)}
				</div>
			)}
		</ProfileModule>
	);
}

export default injectIntl(PromoStatus);